import { PIN_DIALOG_SKIPPED_SESSION } from '../constants';
import { getSessionUUIDToken, getStorageItem, setStorageItem } from './storage';

/**
 * Marks the current login session as the one where the create-PIN promo dialog must stay hidden.
 * Used both when the user skips the dialog and when the user passed registration in this session.
 */
export const skipPinDialogForCurrentSession = (): void => {
  const sessionUuid = getSessionUUIDToken();

  if (!sessionUuid) {
    return;
  }

  setStorageItem(PIN_DIALOG_SKIPPED_SESSION, sessionUuid);
};

export const isPinDialogSkippedForCurrentSession = (): boolean => {
  const sessionUuid = getSessionUUIDToken();

  if (!sessionUuid) {
    return false;
  }

  return getStorageItem(PIN_DIALOG_SKIPPED_SESSION) === sessionUuid;
};
